import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from './git.schema';

export const gitAutomationContract = {
  triggerEndpointsDiscoveryFromCode: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{applicationId}/endpoints-discovery/trigger',
      summary:
        'Trigger endpoint discovery from code repositories for an application',
      inputStructure: 'detailed',
      successStatus: 202,
    })
    .input(z.object({ params: ApplicationsIdSchema, body: z.object({}) }))
    .output(z.object({ message: z.string() }))
    .errors({
      INTERNAL_SERVER_ERROR: {
        status: 500,
        data: z.object({ message: z.string() }),
      },
    }),
  triggerDeepSecurityTestCaseScan: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/{applicationId}/deep-security-scan/trigger',
      summary: 'Trigger an application-wide deep source security scan',
      inputStructure: 'detailed',
      successStatus: 202,
    })
    .input(z.object({ params: ApplicationsIdSchema, body: z.object({}) }))
    .output(
      z.object({
        executionId: z.string(),
        message: z.string(),
      }),
    )
    .errors({
      INTERNAL_SERVER_ERROR: {
        status: 500,
        data: z.object({ message: z.string() }),
      },
    }),
} as const;
